// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chartsModal__erf2h {
  width: 100vw;
  height: 100vh;
}

.modalBody__WjfjJ {
  height: 100%;
  overflow-y: auto;
}
.modalBody__WjfjJ::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 3px;
}
.modalBody__WjfjJ::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.modalBody__WjfjJ::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
.modalBody__WjfjJ::-webkit-scrollbar-thumb:hover {
  background: #888;
  border-radius: 3px;
}

.closeIcon__xu1m8 {
  position: absolute;
  top: 23px;
  right: 25px;
  cursor: pointer;
  z-index: 2;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/ChartsModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,gBAAA;AAzEF;AAkBE;EACE,UAAA;EACA,WAAA;EACA,kBAAA;AAhBJ;AAmBE;EACE,+BAAA;EACA,kBAAA;AAjBJ;AAoBE;EACE,8BAAA;EACA,kBAAA;AAlBJ;AAqBE;EACE,gBAAA;EACA,kBAAA;AAnBJ;;AA6DA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,UAAA;AA1DF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.chartsModal {\n  width: 100vw;\n  height: 100vh;\n}\n\n.modalBody {\n  height: 100%;\n  overflow-y: auto;\n\n  @include scrollBar;\n}\n\n.closeIcon {\n  position: absolute;\n  top: 23px;\n  right: 25px;\n  cursor: pointer;\n  z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chartsModal": `chartsModal__erf2h`,
	"modalBody": `modalBody__WjfjJ`,
	"closeIcon": `closeIcon__xu1m8`
};
module.exports = ___CSS_LOADER_EXPORT___;
